import { createContext, useContext, useEffect, useReducer } from "react";

import axios from "../../api/axios";
import { STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities";
import {
  testsReducer,
  INITIAL_STATE,
  types,
} from "../../reducers/inventory/testsActiveReducer";
import { useActionsTest } from "./TestFormProvider";
import { useNavigate } from "react-router-dom";
const TestIndexActiveContext = createContext({});
const TestIndexActiveProvider = ({ children }) => {
  const [state, dispatch] = useReducer(testsReducer, INITIAL_STATE);
  const actionsTest = useActionsTest();
  let navigate = useNavigate();
  useEffect(() => {

      axios()
        .get(`inventory/getTestsActive`, {
          params: state.tests.filter,
        })
        .then(({ data }) => {
          dispatch({
            type: types.SET_TESTS_LOADED,
            payload: data,
          });
        })
        .catch((e) => {
          showTypeErrorFetch(e);
        });
    
  }, [ state.tests.filter]);
  const updateFieldTest = (test_id, form) => {
    axios()
      .post(`inventory/test/${test_id}`, form)
      .then(({ data }) => {
        dispatch({
          type: types.RELOAD_TESTS,
        });
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const goToTest = (item_id) => {
    actionsTest.loadTest(item_id);
    navigate("/inventory/test");
  };
  return (
    <TestIndexActiveContext.Provider
      value={[state, dispatch, { goToTest, updateFieldTest }]}
    >
      {children}
    </TestIndexActiveContext.Provider>
  );
};
const useTests = () => useContext(TestIndexActiveContext)[0];
const useDispatchTestIndex = () => useContext(TestIndexActiveContext)[1];
const useActionsTests = () => useContext(TestIndexActiveContext)[2];

export {
  TestIndexActiveContext,
  useTests,
  useDispatchTestIndex,
  useActionsTests,
};
export default TestIndexActiveProvider;
